const UPLOAD_URL = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/october-sale-iport`

export const bannerList = [
	{
		desktop: `${UPLOAD_URL}/desktop_1.jpg`,
		tablet: `${UPLOAD_URL}/tablet_1.jpg`,
		mobile: `${UPLOAD_URL}/mobile_1.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_2.jpg`,
		tablet: `${UPLOAD_URL}/tablet_2.jpg`,
		mobile: `${UPLOAD_URL}/mobile_2.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_3.jpg`,
		tablet: `${UPLOAD_URL}/tablet_3.jpg`,
		mobile: `${UPLOAD_URL}/mobile_3.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_4.jpg`,
		tablet: `${UPLOAD_URL}/tablet_4.jpg`,
		mobile: `${UPLOAD_URL}/mobile_4.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_5.jpg`,
		tablet: `${UPLOAD_URL}/tablet_5.jpg`,
		mobile: `${UPLOAD_URL}/mobile_5.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_6.jpg`,
		tablet: `${UPLOAD_URL}/tablet_6.jpg`,
		mobile: `${UPLOAD_URL}/mobile_6.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_7.jpg`,
		tablet: `${UPLOAD_URL}/tablet_7.jpg`,
		mobile: `${UPLOAD_URL}/mobile_7.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_8.jpg`,
		tablet: `${UPLOAD_URL}/tablet_8.jpg`,
		mobile: `${UPLOAD_URL}/mobile_8.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_9.jpg`,
		tablet: `${UPLOAD_URL}/tablet_9.jpg`,
		mobile: `${UPLOAD_URL}/mobile_9.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/desktop_10.jpg`,
		tablet: `${UPLOAD_URL}/tablet_10.jpg`,
		mobile: `${UPLOAD_URL}/mobile_10.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/double_1-desk.jpg`,
		tablet: `${UPLOAD_URL}/double_1-desk.jpg`,
		mobile: `${UPLOAD_URL}/double_1-mob.jpg`
	},
	{
		desktop: `${UPLOAD_URL}/double_2-desk.jpg`,
		tablet: `${UPLOAD_URL}/double_2-desk.jpg`,
		mobile: `${UPLOAD_URL}/double_2-mob.jpg`
	}
]

export const blockData = [
	{
		type: 'banner',
		imgAlt: 'Выгода до 20 000 ₽ на популярные товары',
		imgDeskHeight: 400,
		imgDeskWidth: 1440,
		imgTabletHeight: 768,
		imgTabletWidth: 768,
		imgMobHeight: 768,
		imgMobWidth: 768,
		imgSrcDesk: bannerList[0].desktop,
		imgSrcTablet: bannerList[0].tablet,
		imgSrcMob: bannerList[0].mobile,
		link: `/`,
		title: 'Выгода до 20 000 ₽ на популярные товары',
		order: 1
	},
	{
		type: 'categories',
		order: 2
	},
	{
		type: 'products',
		products: [
			{ KOD: `139101`, SORT: `1` },
			{ KOD: `139100`, SORT: `2` },
			{ KOD: `102962`, SORT: `3` },
			{ KOD: `106124`, SORT: `4` },
			{ KOD: `115005`, SORT: `5` },
			{ KOD: `126848`, SORT: `6` },
			{ KOD: `126849`, SORT: `7` },
			{ KOD: `126886`, SORT: `8` }
		],
		link: `/sales/spetsialnye-ceny-na-iphone/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Оставайтесь на связи',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[1].desktop,
			imgSrcTablet: bannerList[1].tablet,
			imgSrcMob: bannerList[1].mobile,
			link: `/sales/spetsialnye-ceny-na-iphone/`
		},
		order: 3
	},
	{
		type: 'banner',
		imgAlt: 'Получайте подарки до 3 000 ₽ при покупке iPhone',
		imgDeskHeight: 380,
		imgDeskWidth: 1440,
		imgTabletHeight: 645,
		imgTabletWidth: 620,
		imgMobHeight: 768,
		imgMobWidth: 768,
		imgSrcDesk: bannerList[2].desktop,
		imgSrcTablet: bannerList[2].tablet,
		imgSrcMob: bannerList[2].mobile,
		link: `/sales/poluchite-3000-rubley-v-podarok-pri-pokupke-iphone/`,
		title: 'Получайте подарки до 3 000 ₽ при покупке iPhone',
		order: 4
	},
	{
		type: 'products',

		products: [
			{ KOD: `114586`, SORT: `1` },
			{ KOD: `114614`, SORT: `2` },
			{ KOD: `133641`, SORT: `3` },
			{ KOD: `124361`, SORT: `4` },
			{ KOD: `130265`, SORT: `5` },
			{ KOD: `130421`, SORT: `6` },
			{ KOD: `126405`, SORT: `7` },
			{ KOD: `130263`, SORT: `8` }
		],
		link: `/sales/spetsialnye-tseny-na-macbook/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Повышайте продуктивность',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[3].desktop,
			imgSrcTablet: bannerList[3].tablet,
			imgSrcMob: bannerList[3].mobile,
			link: `/sales/spetsialnye-tseny-na-macbook/`
		},
		order: 5
	},
	{
		type: 'banner',
		imgAlt: 'Подарки до 2 000 ₽ при покупке MacBook',
		imgDeskHeight: 400,
		imgDeskWidth: 1440,
		imgTabletHeight: 645,
		imgTabletWidth: 620,
		imgMobHeight: 768,
		imgMobWidth: 768,
		imgSrcDesk: bannerList[4].desktop,
		imgSrcTablet: bannerList[4].tablet,
		imgSrcMob: bannerList[4].mobile,
		link: `/sales/podarki-do-2-000-pri-pokupke-macbook/`,
		title: 'Подарки до 2 000 ₽ при покупке MacBook',
		order: 6
	},
	{
		type: 'products',

		products: [
			{ KOD: `116737`, SORT: `1` },
			{ KOD: `106299`, SORT: `2` },
			{ KOD: `113811`, SORT: `3` },
			{ KOD: `135471`, SORT: `4` },
			{ KOD: `135652`, SORT: `5` },
			{ KOD: `135485`, SORT: `6` },
			{ KOD: `135655`, SORT: `7` },
			{ KOD: `135639`, SORT: `8` }
		],
		link: `/sales/spetsialnye-ceny-na-ipad/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Скидка на iPad аксессуары',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[5].desktop,
			imgSrcTablet: bannerList[5].tablet,
			imgSrcMob: bannerList[5].mobile,
			link: `/sales/spetsialnye-ceny-na-ipad/`
		},
		order: 7
	},
	{
		type: 'products',
		products: [
			{ KOD: `130369`, SORT: `1` },
			{ KOD: `130373`, SORT: `2` },
			{ KOD: `115085`, SORT: `3` },
			{ KOD: `126990`, SORT: `4` },
			{ KOD: `115082`, SORT: `5` },
			{ KOD: `130256`, SORT: `6` },
			{ KOD: `115101`, SORT: `7` },
			{ KOD: `127015`, SORT: `8` }
		],
		link: `/sales/spetsialnye-tseny-na-apple-watch/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Скидка на Apple Watch аксессуары',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[6].desktop,
			imgSrcTablet: bannerList[6].tablet,
			imgSrcMob: bannerList[6].mobile,
			link: `/sales/spetsialnye-tseny-na-apple-watch/`
		},
		order: 8
	},
	{
		type: 'doubleBanner', // Новый тип "doubleBanner" с двумя баннерами
		banners: [
			{
				imgAlt: 'Рассрочка до 18 месяцев на технику Apple',
				title: 'Рассрочка до 18 месяцев на технику Apple',
				imgDeskWidth: 710,
				imgDeskHeight: 220,
				imgMobHeight: 500,
				imgMobWidth: 620,
				imgSrcDesk: bannerList[10].desktop,
				imgSrcMob: bannerList[10].mobile,
				link: `/sales/rassrochka-0-0-18-na-tekhniku-apple/`
			},
			{
				imgAlt: '15% кэшбек при оплате картой Альфа-банка',
				title: '15% кэшбек при оплате картой Альфа-банка',
				imgDeskWidth: 710,
				imgDeskHeight: 220,
				imgMobHeight: 500,
				imgMobWidth: 620,
				imgSrcDesk: bannerList[11].desktop,
				imgSrcMob: bannerList[11].mobile,
				link: `/sales/15-keshbek-pri-oplate-kartoy-alfa-banka/`
			}
		],
		order: 10
	},
	{
		type: 'products',
		products: [
			{ KOD: `75956`, SORT: `1` },
			{ KOD: `120053`, SORT: `2` },
			{ KOD: `116819`, SORT: `3` },
			{ KOD: `115066`, SORT: `4` },
			{ KOD: `127322`, SORT: `5` },
			{ KOD: `99696`, SORT: `6` },
			{ KOD: `99695`, SORT: `7` },
			{ KOD: `139223`, SORT: `8` }
		],
		link: `/sales/spetsialnye-tseny-na-airpods/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Скидка на AirPods аксессуары',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[7].desktop,
			imgSrcTablet: bannerList[7].tablet,
			imgSrcMob: bannerList[7].mobile,
			link: `/sales/spetsialnye-tseny-na-airpods/`
		},
		order: 9
	},
	{
		type: 'products',
		products: [
			{ KOD: `127384`, SORT: `1` },
			{ KOD: `130545`, SORT: `2` },
			{ KOD: `121920`, SORT: `3` },
			{ KOD: `99598`, SORT: `4` },
			{ KOD: `104517`, SORT: `5` },
			{ KOD: `110608`, SORT: `6` },
			{ KOD: `139942`, SORT: `7` },
			{ KOD: `106894`, SORT: `8` }
		],
		link: `/sales/spetsialnye-tseny-na-aksessuary/`,
		buttonLabel: 'Посмотреть все',
		banner: {
			imgAlt: 'Скидка на AirPods аксессуары',
			imgDeskWidth: 556,
			imgDeskHeight: 468,
			imgTabletHeight: 500,
			imgTabletWidth: 620,
			imgMobHeight: 560,
			imgMobWidth: 600,
			imgSrcDesk: bannerList[8].desktop,
			imgSrcTablet: bannerList[8].tablet,
			imgSrcMob: bannerList[8].mobile,
			link: `/sales/spetsialnye-tseny-na-aksessuary/`
		},
		order: 11
	},
	{
		type: 'banner',
		imgAlt: 'Выгода до 3 000 ₽ при покупке по обмену в Трейд-ин',
		imgDeskHeight: 380,
		imgDeskWidth: 1440,
		imgTabletHeight: 645,
		imgTabletWidth: 620,
		imgMobHeight: 768,
		imgMobWidth: 768,
		imgSrcDesk: bannerList[9].desktop,
		imgSrcTablet: bannerList[9].tablet,
		imgSrcMob: bannerList[9].mobile,
		link: `/sales/top_up_iphone/`,
		title: 'Выгода до 3 000 ₽ при покупке по обмену в Трейд-ин',
		order: 12
	},
	{
		type: 'whyIport',
		order: 13
	}
]

export const extraListData = [
	'Уже сейчас в наших розничных магазинах вас ждут прототипы всей линейки iPhone 17, представленные в разных цветах.'
]

export const listData = [
	{
		title: 'Выгода до 5&nbsp;000&nbsp;₽ при покупке аксессуаров',
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/card-image-4.png',
		tip: `При покупке iPhone 17 или iPhone 17 Air вы получаете выгоду до 3 000 ₽ на комплект; при покупке iPhone 17 Pro и iPhone 17 Pro Max — до 5 000 ₽.`
	},
	{
		title: '2 года&nbsp; гарантии <br/>на новое устройство',
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/card-image-1.png',
		tip: `При покупке любой модели нового iPhone 17 в iPort вы получаете гарантию 2 года.`
	},
	{
		title: 'Дополнительная выгода &nbsp;5 000&nbsp;₽ по&nbsp;по обмену в Трейд-ин',
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/card-image-3.png',
		tip: `При обмене в Трейд-ин вашего iPhone вы получаете дополнительную скидку в размере 5 000 ₽ к оценочной стоимости устройства на покупку любой модели iPhone 17.`
	},
	{
		title: 'Возможность приобретения в рассрочку 0-0-36*',
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/promo/iphone-17/card-image-2.png',
		tip: `При покупке iPhone 17 вы можете воспользоваться действующими кредитными предложениями.`
	}
]

export const stepsItems = [
	{
		subtitle: `Выберите один из вариантов покупки: Сертификат или Лимитированное предложение, включающее в себя Сертификат и Limited Box. 
Нажмите кнопку «Купить».`
	},
	{
		subtitle: `Выберите способ получения, подтвердите заказ и оплатите его.`
	},
	{
		subtitle: `После презентации Apple в течение трёх рабочих дней с вами свяжется оператор контактного центра для уточнения деталей по предзаказу: модель, цвет и объём памяти.`
	},
	{
		subtitle: `После получения подтверждения о готовности заказа к выдаче оплатите оставшуюся стоимость за товар и получите ваш заказ.`
	}
]
